import { getExtendedStats } from './stats';

/**
 * Calculate aggregated statistics across all exchanges
 * @param {Object} allPositions - AllPositions object with binance, hyperliquid, lighter, extended
 * @returns {Object} Aggregated stats: { totalAggFunding, avgYearlyYield, totalBalance, totalPnL, totalUnrealizedPnl }
 */
export function getAggregatedStats(allPositions) {
  if (!allPositions) {
    return {
      totalAggFunding: 0,
      avgYearlyYield: 0,
      totalBalance: 0,
      totalPnL: 0,
      totalUnrealizedPnl: 0
    };
  }

  const exchanges = ['binance', 'bybit', 'okx', 'hyperliquid', 'lighter', 'extended'];
  let totalFunding = 0;
  let totalBalance = 0;
  let totalPnL = 0;
  let totalUnrealizedPnl = 0;
  let totalNotional = 0;
  let weightedYieldSum = 0;
  let totalWeight = 0;

  exchanges.forEach(exchangeKey => {
    const exchange = allPositions[exchangeKey];
    if (!exchange || !exchange.positions) return;

    const positions = exchange.positions;
    const stats = getExtendedStats(positions);

    if (stats) {
      totalFunding += stats.totalFunding;
      totalPnL += stats.totalPnL;
      totalUnrealizedPnl += stats.totalUnrealizedPnl;
      totalNotional += stats.totalNotional;

      // Weight yearly yield by notional value
      if (stats.totalNotional > 0 && stats.fundingPercentYearly !== undefined) {
        weightedYieldSum += stats.fundingPercentYearly * stats.totalNotional;
        totalWeight += stats.totalNotional;
      }
    }

    totalBalance += exchange.total_balance || 0;
  });

  // Calculate weighted average yearly yield
  const avgYearlyYield = totalWeight > 0 ? weightedYieldSum / totalWeight : 0;

  return {
    totalAggFunding: totalFunding,
    avgYearlyYield,
    totalBalance,
    totalPnL,
    totalUnrealizedPnl
  };
}

